export default __webpack_public_path__ + "static/media/1112.b6657646.JPG";